// Shim to ensure @dagrejs/graphlib is available for @dagrejs/dagre
// This helps webpack resolve the dependency correctly
// Using require to help webpack resolve the dynamic dependency
const dagre = require("@dagrejs/dagre");
export default dagre.default || dagre;
